<template>
  <v-navigation-drawer
    v-model="show"
    disable-route-watcher
    fixed
    floating
    :temporary="temporary"
    :class="['elevation-5 text-xs-center', { temporary, clipped: !temporary }]"
  >
    <v-list class="list-container">
      <!-- Title -->
      <slot name="title" :title="title">
        <v-list-tile>
          <div class="headline font-weight-light blue-grey--text">{{title}}</div>
        </v-list-tile>
      </slot>
      <!-- Default slot for more list-tiles -->
      <slot />
      <!-- Back to home button -->
      <v-btn class="btn-home" color="light-blue" dark round :to="{ name: 'home' }">
        <v-icon>home</v-icon>
        <span class="pl-2">APPS</span>
      </v-btn>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
/**
 * A sidebar with some common used practices that renders a list of components.
 * It has a title and a button at the bottom of the sidebar to bo back to home.
 */
export default {
  props: {
    /* Makes the sidebar a temporary one that is hidden when clicked outside */
    temporary: {
      type: Boolean,
      default: false
    },
    /* The title of the sidebar, you can override it with the "title" named slot that
     * has the title as slot prop */
    title: {
      type: String,
      default: "Configuraciones"
    },
    /* Controls the visibility of the sidebar with v-model */
    value: {
      type: Boolean,
      default: true
    }
  },
  data: function() {
    return {
      /* Inner control of the visibility of the sidebar */
      show: this.value
    };
  },
  watch: {
    /* Emit 'input' event to work with a custom v-model directive in this component */
    show() {
      this.$emit("input", this.show);
    },
    /* Change the inner control of visibility if the external value changes */
    value() {
      this.show = this.value;
    }
  }
};
</script>

<style scoped>
.list-container {
  height: 100%;
  padding-bottom: 60px;
  overflow-y: auto;
}

.btn-home {
  position: absolute;
  bottom: 10px;
  right: calc(50% - 59px);
}

.temporary {
  height: 100vh;
}

.clipped {
  height: calc(100vh - 64px) !important;
  margin-top: 64px !important;
  z-index: 1;
}
</style>